import { AppstoreAddOutlined, BookOutlined } from "@ant-design/icons";
import { Tabs } from "antd";
import React from "react";
import IndexSubscriptionView from "./IndexSubscriptionList";
import IndexManagement from "../IndexManagement/index";

export default function IndexSubscription() {
  const items = [
    {
      label: (
        <div>
          <BookOutlined />
          数据订阅
        </div>
      ),
      key: "subscription",
      children: <IndexSubscriptionView />,
    },
    {
      label: (
        <div>
          <AppstoreAddOutlined />
          指标创建
        </div>
      ),
      key: "create",
      children: <IndexManagement />,
    },
  ];
  return <Tabs items={items} defaultActiveKey="subscription" />;
}
